
module.exports = require('./promise')

/* istanbul ignore next */
if (!module.exports) {
  console.error('The file "%s" requires `Promise`,', module.parent.filename)
  console.error('but neither `bluebird` nor the native `Promise` implementation were found.')
  console.error('Please install `bluebird` yourself.')
  process.exit(1)
}



//////////////////
// WEBPACK FOOTER
// ./~/native-or-bluebird/index.js
// module id = 27
// module chunks = 0 1